import { Component } from '@angular/core';
import { ATMEventData, EventBusService, EventType } from '../services/eventbus.service';
import { IUserAlert } from '../models/useralert';
import { AlertType } from '../models/alert-type.enum';

@Component({
    selector: 'app-user-alert',
    templateUrl: './user-alert.component.html',
    styleUrls: ['./user-alert.component.scss']
})
export class UserAlertComponent {

    userAlert: IUserAlert | null = null;
    alertClass = 'user-alert-info';

    constructor(private eventBusService: EventBusService) {
        this.eventBusService.getEventBus(EventType.SET_USER_ALERT_EVENT)
            .subscribe((eventData: ATMEventData) => this.updateAlert(eventData.data as IUserAlert));

        this.eventBusService.getEventBus(EventType.CLEAR_USER_ALERT_EVENT)
            .subscribe(() => {
                this.userAlert = null;
                this.alertClass = 'user-alert-info';
            });
    }

    private updateAlert(alert: IUserAlert): void {
        this.userAlert = alert;
        this.alertClass = this.getAlertClass(alert?.alertType);
    }

    private getAlertClass(alertType: AlertType | undefined): string {
        switch (alertType) {
            case AlertType.WARNING:
                return 'user-alert-warning';
            case AlertType.SEVERE:
                return 'user-alert-severe';
            case AlertType.INFO:
            default:
                return 'user-alert-info';
        }
    }
}
